<template>
  <gj-modal
      notFooterPadding
      size="1200_auto"
      :class="modalClass"
      :visible.sync="modalVisible"
      :confirmLoading="confirmLoading"
      @cancel="cancel"
      @confirm="confirm">
    <template #header>新增否定关键词</template>
    <template #content>
      <el-form
          ref="form"
          :model="form">
        <app-base-info
            ref="base"
            :market-id="marketId"
            :form="form.baseInfoForm"
            :campaign-target-type="isMeaningless(campaign)"
            :campaign-target-type-option="[
              {id: AdGroupEnum.SP.targetingType.KEYWORD, text: '关键词投放'},
              {id: AdGroupEnum.SP.targetingType.AUTO, text: '自动投放'}
            ]"
            :campaign="campaign"
            :group="group"
            :group-select="dimension === AdNegKeywordEnum.SP.dimension.GROUP"
        >
        </app-base-info>
        <app-neg-keyword-picker
            ref="picker"
            :form="form.keywordPickerForm"
            title="否定关键词"
            :matchTypeOption="AdNegKeywordEnum.SP.matchTypeOption"
        ></app-neg-keyword-picker>
      </el-form>
    </template>
  </gj-modal>
</template>

<script>
  import {isMeaningfulMixin, isMeaninglessMixin, modalMixIn} from "@/minxins";
  import AppBaseInfo from "../common/base-info";
  import AppNegKeywordPicker from "../common/neg-keyword-picker";
  import {AdCampaignEnum, AdGroupEnum, AdNegKeywordEnum} from "modules/ad/common/enum";
  import { SP } from "@/api/ad";

  export default {
    name: "app-add-sp-ad-neg-keyword",
    components: {AppNegKeywordPicker, AppBaseInfo},
    mixins: [modalMixIn, isMeaninglessMixin, isMeaningfulMixin],
    props: {
      marketId: {
        required: true
      },
      dimension: {
        type: Number,
        required: true
      },
      campaign: {
        required: false,
        default: null
      },
      group: {
        required: false,
        default: null
      }
    },
    data() {
      return {
        form: {
          baseInfoForm: {
            campaignTargetType: null,
            campaignId: null,
            campaignName: null,
            groupId: null,
            groupName: null
          },
          keywordPickerForm: {
            items: [],
            matchType: AdNegKeywordEnum.SP.matchType.NEGATIVE_EXACT
          }
        },
        AdGroupEnum: AdGroupEnum,
        AdNegKeywordEnum: AdNegKeywordEnum
      }
    },
    watch: {
      campaign: {
        handler: function(campaign) {
          if (this.isMeaningful(campaign)) {
            if (campaign.targetingType === AdCampaignEnum.SP.targetingType.MANUAL) {
              this.form.baseInfoForm.campaignTargetType = AdGroupEnum.SP.targetingType.KEYWORD;
            } else if (campaign.targetingType === AdCampaignEnum.SP.targetingType.AUTO) {
              this.form.baseInfoForm.campaignTargetType = AdGroupEnum.SP.targetingType.AUTO;
            }
          }
        },
        immediate: true
      }
    },
    computed: {
      modalClass() {
        if (this.isMeaningful(this.group)) {
          return 'gj-modal_1060X585';
        }
        return this.dimension === AdNegKeywordEnum.SP.dimension.GROUP
          ? 'gj-modal_1060X674'
          : 'gj-modal_1060X607';
      }
    },
    methods: {
      confirm() {
        this.confirmLoading = true;
        let formValid = ['base', 'picker']
          .map(e => this.$refs[e]?.formValidate());
        Promise.all([...formValid])
          .then(() => this.negativeKeywordsAdd())
          .catch((error) => {
            this.confirmLoading = false;
            console.warn('zs', error);
          })
      },
      negativeKeywordsAdd() {
          let params = {
            marketId: this.marketId,
            params: this.form.keywordPickerForm.items.map(e => ({
              keywordText: e.keyword,
              campaignId: this.form.baseInfoForm.campaignId,
              matchType: e.matchType
            })),
          };
          this.confirmLoading = true;
          Promise.resolve(this.dimension)
            .then((dimension) => {
              if (dimension === AdNegKeywordEnum.SP.dimension.CAMPAIGN) {
                return SP.campaignNegativeKeywordsAdd(params);
              } else {
                params.params = params.params.map(e => ({
                  ...e,
                  groupId: this.form.baseInfoForm.groupId
                }))
                return SP.negativeKeywordsAdd(params);
              }
            })
            .then(({ msg, isError }) => {
              this.$gjMessage[isError ? 'error' : 'success'](msg);
              this.$gjDestroy();
              this.$emit('created');
            })
            .complete(() => this.confirmLoading = false);
      }
    }
  }
</script>

<style lang="scss" scoped>
  @import "../../../../../common/common";
</style>


